import Widget from "./base.js";
import { ApMaps } from "./../ap-maps.js";

export class ApMapsWidget extends Widget {
	renderContent() {
		return <ApMaps {...this.props} />;
	}
}
